import React, { Component } from "react";
import Translate from "../translations/Translate";
import { Link } from "react-router-dom";

const languages = [
  { code: "en", label: "English", to: "/" },
  { code: "es", label: "Español", to: "/intl/es" },
  { code: "cn", label: "中文", to: "/intl/cn" },
  { code: "pt", label: "Português", to: "/intl/pt" },
  { code: "de", label: "Deutsche", to: "/intl/de" },
  { code: "fr", label: "Français", to: "/intl/fr" },
  { code: "nl", label: "Nederlands", to: "/intl/nl" },
  { code: "no", label: "Norsk", to: "/intl/no" },
  { code: "tr", label: "Türk", to: "/intl/tr" },
];

class Nav extends Component {
  render() {
    const homePath =
      this.props.value === "en" ? "/" : `/intl/${this.props.value}`;

    return (
      <div className="nav-wrapper">
        <nav className="site-nav" role="navigation">
          <div id="menuToggle">
            <input type="checkbox" aria-label="Open menu" />

            <span />
            <span />
            <span />

            <ul id="menu">
              <li className="navmenuitem">
                <Link to={homePath}>
                  <i className="material-icons nav-icon">home</i>
                  <Translate string="menu.home" />
                </Link>
              </li>

              <li className="navmenuitem">
                <Link to="/api-introduction">
                  <i className="material-icons nav-icon">api</i>
                  <Translate string="menu.api" />
                </Link>
              </li>

              <li className="navmenuitem">
                <Link to="/how-to-use-pnrconverter">
                  <i className="material-icons nav-icon">flight_takeoff</i>
                  <Translate string="menu.how-it-works" />
                </Link>
              </li>

              <li className="navmenuitem">
                <Link to="/about-us">
                  <i className="material-icons nav-icon">group</i>
                  <Translate string="menu.about-us" />
                </Link>
              </li>

              <li className="navmenuitem">
                <Link to="/blog">
                  <i className="material-icons nav-icon">feed</i>
                  <Translate string="menu.blog" />
                </Link>
              </li>

              <li className="navmenuitem language-menu">
                <button type="button" className="lang-menu-item">
                  <img
                    src={`/images/languages/${this.props.value}.svg`}
                    className="langImage"
                    alt=""
                    aria-hidden="true"
                  />
                  <span>{this.props.value}</span>
                  <i className="material-icons nav-icon">expand_more</i>
                </button>

                <ul className="languageDropdown">
                  {languages.map((language) => (
                    <li key={language.code}>
                      <Link to={language.to}>
                        <img
                          className="flag"
                          src={`/images/languages/${language.code}.svg`}
                          alt=""
                          aria-hidden="true"
                        />
                        <span>{language.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="social-bar">
                <a href="https://twitter.com/pnrconverter?lang=en">
                  <img
                    src="/images/icons/twitter2.png"
                    alt="Twitter"
                    height="28"
                    width="28"
                  />
                </a>

                <a href="https://www.linkedin.com/company/pnrconverter">
                  <img
                    src="/images/icons/linkdin.png"
                    alt="LinkedIn"
                    height="28"
                    width="28"
                  />
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default Nav;
